module.exports = __webpack_public_path__ + "static/media/4500x3000.3c600a46.jpg";